import { ArrowPathIcon, ClipboardIcon } from "@heroicons/react/24/outline";

export default function Input({
  defaultValue,
  label,
  placeholder,
  labelClassName,
  className = "",
  error,
  touched,
  isDark = false,
  inputClassName,
  onReset,
  type = "text",
  copyable = false,
  fixedPrefix = "",
  ...props
}) {
  return (
    <div className={`${className}`}>
      {label && <label className={`block font-bold mb-1 ${labelClassName} `}>{label}</label>}
      {onReset && props.value && (
        <ArrowPathIcon
          className="w-4 inline-block ml-2 cursor-pointer"
          title="reset"
          onClick={onReset}
        />
      )}
      <div className="flex items-center gap-2">
        {fixedPrefix && <p className="text-xs text-[#606060]">{fixedPrefix}</p>}
        <input
          className={`border border-[#757575] px-4 py-3 rounded w-full placeholder-[#606060] bg-[#F6F5F5] ${inputClassName} focus:border-[#000000] focus:ring-0 focus:outline-none disabled:bg-gray-200 disabled:cursor-not-allowed`}
          defaultValue={defaultValue}
          placeholder={placeholder}
          type={type}
          readOnly={!props.onChange}
          {...props}
        />
        {copyable && (
          <button
            className="cursor-pointer bg-gray-100 rounded-full p-2 hover:bg-gray-200 hover:scale-105 transition-all duration-300 active:scale-95"
            onClick={() => {
              navigator.clipboard.writeText(fixedPrefix + props.value);
            }}>
            <ClipboardIcon className="w-4" />
          </button>
        )}
      </div>
      {error && touched && (
        <p className="text text-red-500" data-tesid="error-text">
          {error}
        </p>
      )}
    </div>
  );
}
